'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var ns = 'SFJS';
var markUid = 0;

var AsyncMetric = function () {
  function AsyncMetric(logger, message, url, perf) {
    _classCallCheck(this, AsyncMetric);

    this.logger = logger;
    this.message = message;
    this.url = url;
    this.perf = undefined;
    if (this._isCompletePerformance(perf)) this.perf = perf;
    this.startTime = Date.now();
    var metricUid = markUid++;
    this.startMark = ns + '-' + this.message + '-' + metricUid + '-start';
    this.endMark = ns + '-' + this.message + '-' + metricUid + '-end';
    this.resolved = false;
    if (this.perf) this.perf.mark(this.startMark);
  }

  _createClass(AsyncMetric, [{
    key: 'log',
    value: function log() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.resolved) return false;

      var duration = this._duration();

      data.clientStartTime = this.startTime;
      if (this.url) data.url = this.url;
      this.logger.metric(this.message, duration, data);

      this._clearMarks();

      return true;
    }
  }, {
    key: 'success',
    value: function success() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.success = true;
      this.log(data);
      this.resolved = true;
    }
  }, {
    key: 'failure',
    value: function failure() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.success = false;
      this.log(data);
      this.resolved = true;
    }
  }, {
    key: '_duration',
    value: function _duration() {
      var legacyDuration = Date.now() - this.startTime;
      if (!this.perf) return legacyDuration;
      this.perf.mark(this.endMark);
      this.perf.measure(this.message, this.startMark, this.endMark);
      var measures = this.perf.getEntriesByName(this.message);
      if (measures.count <= 0) return legacyDuration;
      var measure = this.perf.getEntriesByName(this.message)[0];
      return parseInt(measure.duration, 10);
    }
  }, {
    key: '_clearMarks',
    value: function _clearMarks() {
      //test clear marks separately
      if (!this.perf || this.perf.clearMarks === undefined || this.perf.clearMeasures === undefined) return;
      this.perf.clearMarks(this.startMark);
      this.perf.clearMarks(this.endMark);
      this.perf.clearMeasures(this.message);
    }
  }, {
    key: '_isCompletePerformance',
    value: function _isCompletePerformance(performance) {
      if (!performance || (typeof performance === 'undefined' ? 'undefined' : _typeof(performance)) != 'object') return false;
      return typeof performance.mark == 'function' && typeof performance.measure == 'function' && typeof performance.getEntriesByName == 'function';
    }
  }]);

  return AsyncMetric;
}();

exports.default = AsyncMetric;